module.exports = __webpack_public_path__ + "img/city-outline-blue.0f4e5a13.png";